import type { RoleName } from '@/auth/roles.ts'

export const PAGE_ROLE_MAP: Record<string, RoleName[]> = {
  'home': ['POLICYHOLDER', 'MEMBER'],
  'users': ['POLICYHOLDER', 'MEMBER'],
  'creditors': ['POLICYHOLDER', 'MEMBER'],
  'claims': ['POLICYHOLDER', 'MEMBER'],
  'debtors': ['POLICYHOLDER', 'MEMBER'],
  'notifications': ['POLICYHOLDER', 'MEMBER'],
  'baseData': ['POLICYHOLDER', 'MEMBER'],
  'workBasket': ['ARAG', 'ARAG_ADMIN'],
  'correspondenz': ['ARAG', 'ARAG_ADMIN'],
  'backofficeAdmin': ['ARAG', 'ARAG_ADMIN'],
  'faq': ['POLICYHOLDER', 'MEMBER'],
}

